<template>
	<div>
		<el-card class="box-card">
			<el-form label-width="80px">
				<el-form-item label="状态:">
					<el-radio-group v-model="listQuery.search.state" @change="stateChange">
						<el-radio label="" border>全部</el-radio>
						<el-radio :label="item.value.toString()" v-for="item in state_list" border>{{item.label}}
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="">
					<el-row :gutter="5">
						<el-col :span="3">
							<el-input v-model="listQuery.search.task_id" placeholder="请输入任务ID"></el-input>
						</el-col>
						<el-col :span="2">
							<el-button type="primary" icon="el-icon-search" @click="keySearch">搜索</el-button>
						</el-col>
						<el-col :span="4">
							<el-popconfirm style="margin-left: 30px;" v-if="checkbox_data.length>0" @confirm="sh(checkbox_data)"
								@onConfirm="sh(checkbox_data)" title="确定批量收货吗？">
								<el-button icon="el-icon-box" type="success" slot="reference">
									批量确认收货
								</el-button>
							</el-popconfirm>
						</el-col>
					</el-row>
				</el-form-item>
			</el-form>
		</el-card>

		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small"
				@selection-change="changeFun">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column type="expand">
					<template slot-scope="props">
						<el-form label-position="left" inline class="demo-table-expand">
							<el-form-item label="下单账号:">
								<span>{{props.row.xd_user}}</span>
							</el-form-item>
							<el-form-item label="下单订单号:">
								<span>{{props.row.xd_order_num}}</span>
							</el-form-item>
							<el-form-item label="下单金额(含运费):">
								<span v-if="props.row.xd_order_money">{{props.row.xd_order_money}}
									({{props.row.coin_name}})</span>
							</el-form-item>
							<el-form-item label="运费:">
								<span v-if="props.row.xd_fs_money">{{props.row.xd_fs_money}}
									({{props.row.coin_name}})</span>
							</el-form-item>
							<el-form-item label="下单截图:">
								<el-image v-if="props.row.xd_imgs" v-for="item in props.row.xd_imgs"
									style="width: 40px; height: 40px" :src="item" fit="fill" :preview-src-list="[item]">
								</el-image>
							</el-form-item>
							<el-form-item label="领取时间:">
								<span>{{ props.row.create_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
							</el-form-item>
							<el-form-item label="下单时间:">
								<span>{{ props.row.xd_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
							</el-form-item>
							<el-form-item label="发货时间:">
								<span>{{ props.row.send_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
							</el-form-item>
							<el-form-item label="确认收货时间:">
								<span>{{ props.row.sh_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
							</el-form-item>
							<el-form-item label="商家评语:">
								<span>{{props.row.comment}}</span>
							</el-form-item>
							<el-form-item label="商家评语图片:">
								<el-image v-if="props.row.comment_imgs" v-for="item in props.row.comment_imgs"
									style="width: 40px; height: 40px" :src="item" fit="fill" :preview-src-list="[item]">
								</el-image>
							</el-form-item>
							<el-form-item label="评论截图:">
								<el-image v-if="props.row.pl_imgs" v-for="item in props.row.pl_imgs"
									style="width: 40px; height: 40px" :src="item" fit="fill" :preview-src-list="[item]">
								</el-image>
							</el-form-item>
							<el-form-item v-if="props.row.pl_time" label="评论时间:">
								<span>{{ props.row.pl_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
							</el-form-item>
							<el-form-item v-if="props.row.state == 9" label="取消时间:">
								<span>{{ props.row.cancel_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
							</el-form-item>
							<el-form-item v-if="props.row.state == 9" label="取消原因:">
								<span>{{props.row.cancel_cause}}</span>
							</el-form-item>
						</el-form>
					</template>
				</el-table-column>
				<el-table-column prop="id" label="ID"> </el-table-column>
				<el-table-column prop="task_id" label="任务ID">
					<template slot-scope="{row}">
						<el-link type="primary" @click="taskHref(row.task_id)">{{row.task_id}}</el-link>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="shop_uid" label="商家 (ID)">
					<template slot-scope="{row}">
						<span>{{row.shop_uid_name}} ({{row.shop_uid}})</span>
					</template>
				</el-table-column> -->
				<el-table-column prop="shop_name" label="店铺"></el-table-column>
				<el-table-column prop="platform_init" label="平台"> </el-table-column>
				<el-table-column prop="country_init" label="国家"> </el-table-column>
				<el-table-column prop="commission_money" label="佣金 (RMB)"></el-table-column>
				<el-table-column prop="comment" label="商家评语">
					<template slot-scope="{row}">
						<el-popover v-if="row.comment" placement="top-start" title="" width="200" trigger="hover"
							:content="row.comment">
							<el-button slot="reference">查看</el-button>
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column prop="comment_imgs" label="商家评语图片">
					<template slot-scope="{row}">
						<el-image v-if="row.comment_imgs" v-for="item in row.comment_imgs"
							style="width: 40px; height: 40px" :src="item" fit="fill" :preview-src-list="row.comment_imgs">
						</el-image>
					</template>
				</el-table-column>
				<el-table-column prop="comment_imgs" label="商家评语视频">
					<template slot-scope="{row}">
						<el-button @click="videoDownload(row.id)" v-if="row.comment_video">下载视频</el-button>
					</template>
				</el-table-column>
				<el-table-column label="状态">
					<template slot-scope="{row}">
						<el-tag :type="row.state_color">
							{{ row.state_init}}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作" fixed="right" width="240px;">
					<template slot-scope="{row,$index}">
						<el-button v-if="row.state == 0" icon="el-icon-sold-out" @click="xd(row.id,row.coin_name)"
							type="primary" size="mini">下单
						</el-button>
						<el-popconfirm style="margin-right: 10px;" v-if="row.state == 2" @confirm="sh(row.id)"
							@onConfirm="sh(row.id)" title="确定收货吗？">
							<el-button icon="el-icon-box" type="success" slot="reference" size="mini">确认收货
							</el-button>
						</el-popconfirm>
						<el-button v-if="row.state == 3" @click="pl(row)" icon="el-icon-chat-line-square" type="warning"
							size="mini">评论</el-button>
						<!-- <el-button v-if="row.state != 9" @click="cancel(row)" icon="el-icon-close" size="mini">取消
						</el-button> -->
						<el-button v-if="row.state != 9 && row.is_complain == 0" @click="ts(row)" icon="el-icon-chat-dot-square"
							type="danger" size="mini">投诉</el-button>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />
			<!-- 下单模态框 -->
			<el-dialog title="下单" :visible.sync="is_show_xd" width="40%">
				<el-form label-position="right" label-width="100px">
					<el-form-item label="下单账号:">
						<el-col :span="16">
							<el-input type="text" v-model="xd_data.xd_user"></el-input>
						</el-col>
					</el-form-item>
					<el-form-item label="订单号:">
						<el-col :span="16">
							<el-input type="text" v-model="xd_data.order_num"></el-input>
						</el-col>
					</el-form-item>
					<el-form-item label="订单金额:">
						<el-col :span="8">
							<el-input-number size="medium" v-model="xd_data.order_money" :precision="2" :min="0"></el-input-number>
							<!-- <el-input type="text" v-model="xd_data.order_money"></el-input> -->
						</el-col>
						<span>{{coin_name}}(包含运费)</span>
					</el-form-item>
					<el-form-item label="运费:">
						<el-col :span="8">
							<el-input-number size="medium" v-model="xd_data.fs_money" :precision="2" :min="0"></el-input-number>
							<!-- <el-input type="text" v-model="xd_data.fs_money"></el-input> -->
						</el-col>
						<span>{{coin_name}}</span>
					</el-form-item>
					<el-form-item label="下单截图:">
						<el-col :span="24">
							<Img @imgList="imgsImg" :img_num="3" :img_edit="xd_data.imgs"></Img>
						</el-col>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_xd = false">返回</el-button>
					<el-button :loading="this.$store.state.ajaxLoading" type="primary" @click="xd2()">确定</el-button>
				</span>
			</el-dialog>
			<!-- 评论模态框 -->
			<el-dialog title="评论" :visible.sync="is_show_pj" width="40%">
				<el-form label-position="right" label-width="100px">
					<el-form-item label="商家评语:">
						<el-col :span="16">
							<span>{{pl_data.comment}}</span>
						</el-col>
					</el-form-item>
					<el-form-item label="商家评语图片:">
						<el-col :span="16">
							<el-image v-for="item in pl_data.comment_imgs" style="width: 40px; height: 40px" :src="item"
								fit="fill" :preview-src-list="[item]">
							</el-image>
						</el-col>
					</el-form-item>
					<div v-if="pl_data.is_collocation == 1" style="margin-bottom: 10px;">
						<el-divider>以下是搭配商品评语</el-divider>
						<el-collapse v-model="activeNames">
							<el-collapse-item v-for="(item,i) in pl_data.collocation" title="搭配商品" :name="i">
								<el-form-item label="商品链接:">
									<el-col :span="16">
										<el-tooltip class="item" effect="dark" :content="item.links" placement="top-start">
										    <el-link type="primary" :href="item.links" target="_blank">点击链接</el-link>
										</el-tooltip>
									</el-col>
								</el-form-item>
								<el-form-item label="商品名称:">
									<el-col :span="16">
										<span>{{item.title}}</span>
									</el-col>
								</el-form-item>
								<el-form-item label="评语:">
									<el-col :span="16">
										<span>{{item.comment}}</span>
									</el-col>
								</el-form-item>
								<el-form-item label="图片:">
									<el-col :span="24">
										<el-image v-for="item2 in item.pj_imgs" style="width: 60px; height: 60px" :src="item2"
											fit="fill" :preview-src-list="[item2]">
										</el-image>
									</el-col>
								</el-form-item>
							</el-collapse-item>
						</el-collapse>
					</div>
					<el-form-item label="评论截图:">
						<el-col :span="24">
							<Img @imgList="imgsImg2" :img_num="1" :img_edit="pl_data.imgs"></Img>
						</el-col>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_pj = false">返回</el-button>
					<el-button :loading="this.$store.state.ajaxLoading" type="primary" @click="pl2()">确定</el-button>
				</span>
			</el-dialog>
			<!-- 取消 -->
			<el-dialog title="取消" :visible.sync="is_show_cancel" width="40%">
				<el-form label-position="right" label-width="100px">
					<el-form-item label="取消原因:">
						<el-col :span="16">
							<el-input :rows="8" type="textarea" placeholder="请输入" maxlength="200" show-word-limit
								v-model="cancel_data.cause">
							</el-input>
						</el-col>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_cancel = false">返回</el-button>
					<el-button type="primary" @click="cancel2()">确定</el-button>
				</span>
			</el-dialog>
			<!-- 投诉 -->
			<el-dialog title="投诉" :visible.sync="is_show_ts" width="40%">
				<el-form label-position="right" label-width="100px">
					<el-form-item label="投诉原因:">
						<el-col :span="16">
							<el-input :rows="4" type="textarea" v-model="ts_data.cause"></el-input>
						</el-col>
					</el-form-item>
					
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_ts = false">返回</el-button>
					<el-button :loading="this.$store.state.ajaxLoading" type="primary" @click="ts2()">确定</el-button>
				</span>
			</el-dialog>
			<!-- 任务详情 -->
			<el-dialog title="任务详情" :visible.sync="is_show_details" width="70%">
				<taskDetails :task_id="details_task_id"></taskDetails>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import {
		orderListInit,
		orderList,
		orderBuy,
		getCoinName,
		orderSh,
		pl,
		orderCancel,
		orderComplain,
		downloadToken
	} from '@/api/jd_task'
	import request from '@/tool/request'
	import {
		parseTime
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	import Dtp from '@/components/Ele/dateTimePicker.vue' // 时间选择组件
	import Img from '@/components/Jd/img.vue' // 上传图片组件
	import taskDetails from '@/components/Jd/taskDetails.vue' // 任务详情组件
	export default {
		name: 'task_order',
		components: {
			Pagination,
			Dtp,
			Img,
			taskDetails
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				is_show_search: false, // 搜索模态框
				data_list: [], // 表格数据
				loading: true,
				is_show_xd: false,
				xd_data: {},
				coin_name: '',
				sh_num: 0,
				checkbox_data: [], // 多选的数组
				state_list: [],
				is_show_pj: false,
				pl_data: {
					comment: '',
					comment_imgs: [],
					imgs: []
				},
				is_show_cancel: false,
				cancel_data: {
					'id': '',
					'cause': '',
				},
				is_show_ts:false,
				ts_data:{},
				is_show_details:false,
				details_task_id:'',
				activeNames:[0,1,2,3,4,5,6]
			};
		},
		filters: {
			parseTime,
		},
		created() {
			this.resetSearchData()
			// 判断是否是从别的路由过来的（因为有组件缓存的关系，所以这里不生效）
			let task_id = this.$route.query.task_id;
			if (task_id) {
				this.listQuery.search.task_id = task_id;
			}

			this.getListInit();
			this.getList()
			this.resetXdData();
		},
		methods: {
			stateChange(){
				this.keySearch();
			},
			keySearch() { // 搜索
				this.listQuery.page = 1
				this.getList()
			},
			resetXdData() {
				this.xd_data = {
					'id': 0,
					'xd_user': '',
					'order_num': '',
					'order_money': '',
					'fs_money': '0',
					'imgs': [],
				};
			},
			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: {
						'state': ''
					}
				}
			},
			resetSearch() { // 重置搜索
				this.resetSearchData()
				this.getList()
			},
			getListInit() {
				orderListInit(Qs.stringify(this.listQuery)).then(response => {
					this.state_list = response.result.state;
				})
			},
			getList() { // 获取列表数据
				this.loading = true;
				orderList(Qs.stringify(this.listQuery)).then(response => {
					this.data_list = response.result.items;
					this.total = response.result.total;
					this.loading = false;
				})
			},
			xd(val, coin_name) {
				// 获取币种
				// getCoinName(Qs.stringify({
				// 	'id': task_id
				// })).then(response => {
				// 	this.coin_name = response.result;
				// })

				this.resetXdData();
				this.xd_data.id = val;
				this.coin_name = coin_name;
				this.is_show_xd = true;
			},
			xd2() {
				this.$store.commit('setAjaxLoading', true);
				orderBuy(Qs.stringify(this.xd_data)).then(response => {
					this.is_show_xd = false;
					this.getList();
					this.$message({
						showClose: true,
						message: '操作成功',
						type: 'success'
					});
				})
			},
			taskHref(task_id) {
				this.is_show_details = true;
				this.details_task_id = task_id;
				//路由跳转
				// this.$router.push({
				// 	path: '/task/list',
				// 	query: {
				// 		id: task_id
				// 	}
				// });
			},
			imgsImg(e) { // 用户图片调用组件时候的回调
				this.xd_data.imgs = e;
			},
			imgsImg2(e) { // 用户图片调用组件时候的回调
				this.pl_data.imgs = e;
			},
			changeFun(val) { // 多选选中的时候，id值的变化
				let arr = [];
				for (let j = 0; j < val.length; j++) {
					let id = val[j]['id'];
					arr[j] = id;
				}
				this.checkbox_data = arr;
			},
			sh(val = '') {
				orderSh(Qs.stringify({
					'id': val
				})).then(response => {
					this.$message({
						showClose: true,
						message: '收货成功',
						type: 'success'
					});
					this.getList();
				})
			},
			pl(row) {
				this.is_show_pj = true;
				this.pl_data.id = row.id;
				this.pl_data.imgs = [];
				this.pl_data.comment = row.comment;
				this.pl_data.comment_imgs = row.comment_imgs;
				this.pl_data.is_collocation = row.is_collocation;
				this.pl_data.collocation = row.collocation;
			},
			pl2() {
				this.$store.commit('setAjaxLoading', true);
				pl(Qs.stringify(this.pl_data)).then(response => {
					this.is_show_pj = false;
					this.$message({
						showClose: true,
						message: '评价成功',
						type: 'success'
					});
					this.getList();
				})
			},
			cancel(val) {
				this.is_show_cancel = true;
				this.cancel_data.id = val.id;
				this.cancel_data.cause = '';
			},
			cancel2() {
				orderCancel(Qs.stringify(this.cancel_data)).then(response => {
					this.is_show_cancel = false;
					this.$message({
						showClose: true,
						message: '取消成功',
						type: 'success'
					});
					this.getList();
				})
			},
			resetTsData() {
				this.ts_data = {
					'id': 0,
					'cause': '',
				};
			},
			ts(row){
				this.resetTsData();
				this.ts_data.id = row.id;
				this.is_show_ts = true;
			},
			ts2(){
				this.$store.commit('setAjaxLoading', true);
				orderComplain(Qs.stringify(this.ts_data)).then(response => {
					this.is_show_ts = false;
					this.$message({
						showClose: true,
						message: '提交成功，请等待处理',
						type: 'success'
					});
					this.getList();
				})
			},
			// 视频下载
			videoDownload(id) {
				// 获取视频下载token
				downloadToken(Qs.stringify()).then(response => {
					let r = response.result;
					let token = r.token;
					let spongeman_id = r.spongeman_id;
					if (token) {
						window.open(process.env.VUE_APP_ADMIN_BASE_URL + "/TaskDownload/commentVidel?spongeman_id="+spongeman_id+"&id=" + id +
							"&token=" + token,
							"_blank");
					}
				})
			}
		}
	}
</script>
<style>
	.el-radio {
		margin-right: 0px;
	}
</style>